package app.footyguide.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import app.footyguide.core.locale.LocalStrings
import app.footyguide.core.locale.AppStrings
import app.footyguide.web.route.WebRoutes

enum class BottomNavItem(
    val route: String,
    val icon: String,
    val label: String
) {
    AGENDA(WebRoutes.HOME, Icons.CALENDAR, "Agenda"),
    MY_TEAM(WebRoutes.MY_TEAM, Icons.SHIELD, "Meu Time"),
    STANDINGS(WebRoutes.STANDINGS, Icons.TROPHY, "Tabelas"),
    CHANNELS(WebRoutes.CHANNELS, Icons.TV, "Canais");

    fun getLabel(strings: AppStrings): String = when(this) {
        AGENDA -> strings.navGames
        MY_TEAM -> strings.myTeamNav
        STANDINGS -> strings.standings
        CHANNELS -> strings.navChannels
    }
}

@Composable
fun BottomNavBar(
    currentRoute: String = "/",
    onNavigate: (String) -> Unit = {}
) {
    val strings = LocalStrings.current
    Nav({
        style {
            position(Position.Fixed)
            bottom(0.px)
            left(0.px)
            right(0.px)
            height(60.px)
            backgroundColor(Color("var(--surface)"))
            property("border-top", "1px solid var(--border)")
            property("box-shadow", "0 -2px 8px rgba(22, 24, 29, 0.04)")
            property("z-index", "90")
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Div({
            style {
                width(100.percent)
                maxWidth(600.px)
                height(100.percent)
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.SpaceAround)
                padding(0.px, 8.px)
            }
        }) {
            BottomNavItem.entries.forEach { item ->
                val isActive = currentRoute == item.route
                Button({
                    classes("fg-bottom-nav-item")
                    if (isActive) {
                        classes("fg-bottom-nav-active-item")
                    }
                    onClick { onNavigate(item.route) }
                    style {
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        alignItems(AlignItems.Center)
                        justifyContent(JustifyContent.Center)
                        gap(3.px)
                        background("none")
                        border(0.px)
                        cursor("pointer")
                        minWidth(64.px)
                        height(48.px)
                        padding(4.px, 8.px)
                        borderRadius(12.px)
                        property("appearance", "none")
                        property("-webkit-appearance", "none")
                    }
                }) {
                    LucideIcon(
                        name = item.icon,
                        size = 20,
                        color = if (isActive) "var(--accent-fill, var(--accent))" else "var(--muted)"
                    )
                    Span({
                        classes("fg-bottom-nav-label")
                        style {
                            fontFamily("Sora, 'Plus Jakarta Sans', -apple-system, sans-serif")
                            fontSize(11.px)
                            fontWeight(if (isActive) 700 else 600)
                            color(if (isActive) Color("var(--accent-fill, var(--accent))") else Color("#8E8E93"))
                            letterSpacing((-0.2).px)
                            property("line-height", "1.2")
                        }
                    }) {
                        Text(item.getLabel(strings))
                    }
                }
            }
        }
    }
}
